import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'
import { API_ROUTES } from '../../../utility/api.routes'


export const getAssessment = createAsyncThunk('assessment/getAssessment', async (studentId) => {
    try {
      const url = API_ROUTES.EXAM.GET_ASSESSMENT(studentId)
      const response = await apiClient.get(url)
      return response?.data?.result
    } catch (error) {
      console.error('builder function error:', error)
      throw error
    }
  })

  export const createAssessment = createAsyncThunk('assessment/createAssessment', async () => {
    try {
      const url = API_ROUTES.EXAM.CREATE_CORRECT_ANS()
      const response = await apiClient.post('/assessment',{})
      return response.data.result
    } catch (error) {
      console.error('builder function error:', error)
      throw error
    }
  })
